import { REACT_APP_API_URL } from '@/helpers/conf';

export const url = REACT_APP_API_URL;

export const ACCOUNT_LINKS = [
  {
    name: 'profileInfo',
    link: '/profile-custom/personal',
  },
  {
    name: 'wallet',
    link: '/profile-custom/cashbox',
  },
  {
    name: 'bonusCabinet',
    link: '/promotions',
  },
];
